import {
  Operations,
  ReportReasonWithRelations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kLocations } from "./locations";

export const kReportReasons: (ReportReasonWithRelations & Operations)[] = [
  {
    id: "a1b2c3d4-e5f6-4789-8123-567890abcdef",
    reason: "Fan Not Working",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "b9a87654-3210-4fed-ba98-76543210fedc",
    reason: "Flickering Light",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "cdef0123-4567-489a-bcde-0123456789ab",
    reason: "Power Outlet Dead",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "98765432-10fe-4dcba-9876-543210fedcba",
    reason: "Chair Height Adjustment Faulty",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "ef012345-6789-4abcd-ef01-23456789abcd",
    reason: "Scratched Desk",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "89abcdef-0123-4567-89ab-cdef01234567",
    reason: "Monitor Not Displaying",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "f0e9d8c7-b6a5-4321-fedc-ba9876543210",
    reason: "Sticky Keys on Keyboard",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "12345678-90ab-4cdef-1234-567890abcdef01",
    reason: "No Wired Network Connection",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "23456789-0abc-4def-2345-67890abcdef012",
    reason: "No Dial Tone on Desk Phone",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "34567890-abcd-4ef1-3456-7890abcdef0123",
    reason: "Paper Jam",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "4567890a-bcde-4f01-4567-890abcdef01234",
    reason: "Projector Not Working",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "567890ab-cdef-4012-5678-90abcdef012345",
    reason: "Whiteboard Hard to Erase",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "67890abc-def0-4234-6789-0abcdef0123456",
    reason: "Locker Lock Jammed",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "7890abcd-ef01-4345-7890-abcdef01234567",
    reason: "Too Cold Near Window",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "890abcdef-0123-4567-890a-bcdef012345678",
    reason: "Dripping Tap in Kitchenette",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "90abcdef0-1234-4567-90ab-cdef0123456789",
    reason: "Coffee Spill",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "0abcdef01-2345-4678-0abc-def0123456789a",
    reason: "Broken Slats on Blinds",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "abcdef012-3456-4789-abcd-ef0123456789ab",
    reason: "Loose Cable",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "bcdef0123-4567-489a-cdef-0123456789abc",
    reason: "Door Not Closing Properly",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "cdef01234-5678-49ab-def0-123456789abcd",
    reason: "Faded Sign",
    location: kLocations[0],
    locationId: kLocations[0].id,
    _operations: {
      canDelete: true,
    },
  },
];
